import { PaneArea } from '../../../../types/shared'
import ElliottWaves, { IElliottWavesAttrs } from '../../../canvas/elliott_waves/elliott_waves'
import PaneModel from '../../../models/pane'
import utils from '../../../utils'

type Area = PaneArea
type Attrs = IElliottWavesAttrs
type PartialAttrs = Partial<Attrs>

class ElliottWavesCreator extends ElliottWaves<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(
      {
        ...values,
        waves: [
          {
            x: startArea.x,
            y: startArea.y,
          },
        ],
      },
      model
    )

    const w = (w: number) => this.model.scale.x.width(w * 8)
    const h = (h: number) => this.model.scale.y.height(h * 16)

    this.attrs.waves[0] = { x: startArea.x, y: startArea.y }
    this.attrs.waves[1] = {
      x: this.attrs.waves[0].x + w(10.833),
      y: this.attrs.waves[0].y - h(3.379),
    }
    this.attrs.waves[2] = {
      x: this.attrs.waves[0].x + w(14.166),
      y: this.attrs.waves[0].y - h(1.126),
    }
    this.attrs.waves[3] = {
      x: this.attrs.waves[0].x + w(31.333),
      y: this.attrs.waves[0].y - h(6.228),
    }
    this.attrs.waves[4] = {
      x: this.attrs.waves[0].x + w(34.5),
      y: this.attrs.waves[0].y - h(4.373),
    }
    this.attrs.waves[5] = {
      x: this.attrs.waves[0].x + w(45.166),
      y: this.attrs.waves[0].y - h(7.819),
    }

    const [left, right] = utils.minMax(this.attrs.waves.map((wave) => wave.x))
    const [top, bottom] = utils.minMax(this.attrs.waves.map((wave) => wave.y))
    this.moveBy(left - (left + right) / 2, top - (top + bottom) / 2)

    setTimeout(() => {
      this.replaceMyself(ElliottWaves.fromObject<ElliottWaves>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default ElliottWavesCreator
